const QuestionType = {
  Radio: "radio",
  Checkbox: "checkbox",
  Spectrum: "spectrum",
  Matrix: "matrix",
  Compound: "compound",
  Text: "text",
};

export default QuestionType;
